<template>
    <div>
        <Logo />
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6">
                <ion-input placeholder="Email" type="email" shape="round" expand="full" v-on:ionInput="setEmail($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                <ion-button shape="round" expand="full" v-on:click="resetPassword()" style='margin-bottom: 12px;'>Reset Password</ion-button>
                <div class="router-nav">
                    <router-link to="/login">Login</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Logo from '@/components/Logo.vue'
import {alerts} from '../../mixins/alerts';

export default {
    name: 'password',
    data : function () {
        return {
            email : ''
        }
    },
    components: {
        Logo
    },
    mixins : [alerts],
    methods : {
        setEmail : function (event) {
            this.email = event.target.value;
        },
        validateEmail : function (email) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,12})+$/.test(email)) {
                return true;
            }
            return false;
        },
        resetPassword : function () {
            let self = this;
            if (!this.validateEmail(this.email)) {
                this.showError('Please enter a valid email address');
                return;
            }
            this.axios.post(this.api + 'auth/forgot', {email : this.email})
                .then(response => {
                    self.showSuccess('We have received your request.  You will receive an email with details of how to reset your password.', function () {
                        self.$router.push({name : 'login'});
                    });
                })
                .catch(error => {
                    console.error('error resetting password', error);
                    self.showError('There was a problem resetting your password.  Are you sure that\'s the right email address?');
                });
        }
    }
}
</script>
